import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const BadSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#A1A1A1"
      fillRule="evenodd"
      d="M15.3 8a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm1.5 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM6.55 7.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5.5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm.275 4.512.348.52-1.039.695-.348-.52a2.985 2.985 0 0 0-2.485-1.327 2.985 2.985 0 0 0-2.483 1.323l-.348.519-1.038-.698.35-.518A4.235 4.235 0 0 1 8.8 9.38c1.47 0 2.764.748 3.524 1.882Z"
      clipRule="evenodd"
    />
  </svg>
)
export default BadSVG
